import { useQuery } from "@tanstack/react-query";
import { getSocialLinks } from "src/api/user/profile";
import { QUERYKEYS } from "src/types/queryKeys";

export const useGetSocialLinks = () => {
  const { data } = useQuery({
    queryKey: [QUERYKEYS.SOCIAL_LINKS],
    queryFn: getSocialLinks,
  });

  return { socialLinks: data ?? null };
};
